<div id="case-detailed-vehicle" class="container-fluid pb-3">
    
    <mat-card>

        <mat-card-content *ngIf="case">

            <div class="row">
                <!-- START COLUMN 1 -->
                <div class="col-sm-4">

                    <div class="row">
                        <div class="col-sm-10">
                            <div class="row no-gutters">
                                <mat-form-field class="full-width">
                                    <mat-label>{{ case.vehicle.trans.plate_number | translate }}</mat-label>
                                    <input id="{{idPrefix}}{{case.vehicle.trans.plate_number}}"
                                           type="text" matInput
                                           [(ngModel)]="case.vehicle.plate_number"
                                           (blur)="patchAndUpdate('vehicle.plate_number')"
                                           uppercase>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <!-- PLACEHOLDER FOR ACTION BUTTONS-->
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-10">
                            <mat-form-field class="full-width">
                                <mat-label>{{ case.vehicle.trans.first_registration | translate }}</mat-label>
                                <input id="{{idPrefix}}{{case.vehicle.trans.first_registration}}"
                                       matInput [matDatepicker]="picker"
                                       [(ngModel)]="case.vehicle.first_registration"
                                       (dateChange)="patchAndUpdateWithValue({ propertyName: 'vehicle.first_registration', value: dateTimeToDateString(case.vehicle.first_registration) })">
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div class="col-sm-2">
                            <!-- PLACEHOLDER FOR ACTION BUTTONS-->
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12">
                           <mileage-input [idPrefix]="(idPrefix + 'mileage.')"
                                          [vehicle]="case.vehicle"
                                          (updated)="patchAndUpdateWithValue($event)"
                                          (multiUpdated)="patchOpDataArray($event)">
                           </mileage-input>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-10">
                            <vin-input [idPrefix]="idPrefix"
                                       class="full-width"
                                       [vin]="case.vehicle.vin"
                                       (updated)="patchAndUpdateWithValue($event)">
                            </vin-input>
                        </div>
                        <div class="col-sm-2">
                            <!-- PLACEHOLDER FOR ACTION BUTTONS-->
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-10">
                            <kba-input [idPrefix]="idPrefix"
                                       [vehicle]="case.vehicle"
                                       (updated)="patchAndUpdateWithValue($event)">
                            </kba-input>
                        </div>
                        <div class="col-sm-2">
                            <!-- PLACEHOLDER FOR ACTION BUTTONS-->
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-10">
                            <div class="row no-gutters">
                                <vehicle-type-manufacturer-select class="full-width"
                                                                  [idPrefix]="idPrefix"
                                                                  [type]="case.vehicle.type"
                                                                  [manufacturer]="case.vehicle.manufacturer"
                                                                  [manufacturerSelectOptions]="manufacturerSelectOptions"
                                                                  [vehicleTypeSelectOptions]="vehicleTypeSelectOptions"
                                                                  (updated)="patchAndUpdateWithValue($event)">
                                </vehicle-type-manufacturer-select>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <!-- PLACEHOLDER FOR ACTION BUTTONS-->
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-10">
                            <div class="row no-gutters">
                                <mat-form-field class="full-width">
                                    <mat-label>{{ case.vehicle.trans.model | translate }}</mat-label>
                                    <input id="{{idPrefix}}{{case.vehicle.trans.model}}"
                                           type="text" matInput
                                           [(ngModel)]="case.vehicle.model"
                                           (blur)="patchAndUpdate('vehicle.model')">
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <!-- PLACEHOLDER FOR ACTION BUTTONS-->
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-10">
                            <div class="row no-gutters">
                                <mat-form-field class="full-width">
                                    <mat-label>{{ case.vehicle.trans.submodel | translate }}</mat-label>
                                    <input id="{{idPrefix}}{{case.vehicle.trans.submodel}}"
                                           type="text" matInput
                                           [(ngModel)]="case.vehicle.submodel"
                                           (blur)="patchAndUpdate('vehicle.submodel')">
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <!-- PLACEHOLDER FOR ACTION BUTTONS-->
                        </div>
                    </div>
                </div>

                <!-- START COLUMN 2 -->
                <div class="col-sm-4">

                    <div class="row">
                        <div class="col-sm-10">
                            <participant-type-select [idPrefix]="(idPrefix + 'vehicle_location.')"
                                                     [selectedId]="case.vehicle.location"
                                                     [options]="participantTypeOptions"
                                                     [existing]="true"
                                                     [excluded]="excludedParticipantTypes"
                                                     [uriBuilderParams]="participantTypeUriBuilderParams"
                                                     (updated)="updateVehicleLocation($event)">
                            </participant-type-select>
                        </div>
                        <div class="col-sm-2">
                            <!-- PLACEHOLDER FOR ACTION BUTTONS-->
                        </div>
                    </div>

                    <div class="row no-gutters">
                        <div class="col-sm-10">
                            <address-participant #addressParticipant
                                                 [idPrefix]="(idPrefix + 'vehicle_location.')"
                                                 [type]="participantTypeVehicleLocation"
                                                 [config]="addressParticipantOptions"
                                                 [disabled]="!!case.vehicle.location">
                            </address-participant>
                        </div>
                        <div class="col-sm-2">
                            <!-- PLACEHOLDER FOR ACTION BUTTONS-->
                        </div>
                    </div>
                </div>

                <!-- START COLUMN 3 -->
                <div class="col-sm-4">

                    <div class="row">
                        <div class="col-sm-10">
                            <div class="row no-gutters">
                                <mat-form-field class="full-width">
                                    <mat-label>{{ case.vehicle.trans.comment | translate }}</mat-label>
                                    <textarea id="{{idPrefix}}{{case.vehicle.trans.comment}}"
                                              matInput
                                              rows="25"
                                              [(ngModel)]="case.vehicle.comment"
                                              (blur)="patchAndUpdate('vehicle.comment')">
                                    </textarea>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-2">
                        <!-- PLACEHOLDER FOR ACTION BUTTONS-->
                    </div>

                </div>
            </div>

        </mat-card-content>
    </mat-card>

</div>
